import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownSelect } from '@marketing/components/funnel/FormFields/DropdownSelect';
import FormInputRegular from '@marketing/components/funnel/FormFields/FormInputRegular';
import { useProfileContext } from '../ProfileContext';
import LocationSearchInput from './LocationSearchInput';
import { addressFieldContainsPOBox, eligibleStates, isValidValue } from '@utils/form_validations';
var AddressInput = function (_a) {
    var apt = _a.apt, city = _a.city, state = _a.state, street = _a.street, zipcode = _a.zipcode, handleAddressSelected = _a.handleAddressSelected, handleStreetChange = _a.handleStreetChange, setApt = _a.setApt, setCity = _a.setCity, setState = _a.setState, setZipcode = _a.setZipcode, setIsValid = _a.setIsValid;
    var serverLoading = useProfileContext().serverLoading;
    var validateApt = function (value) {
        var containsPOBox = addressFieldContainsPOBox(value);
        setIsValid === null || setIsValid === void 0 ? void 0 : setIsValid(!containsPOBox);
        return containsPOBox
            ? {
                isValid: false,
                error: 'We currently do not deliver to PO boxes, please enter a new address',
            }
            : { isValid: true, error: '' };
    };
    var validateCity = function (value) {
        var isValid = isValidValue('city', value);
        if (!isValid) {
            setIsValid === null || setIsValid === void 0 ? void 0 : setIsValid(false);
            return {
                isValid: false,
                error: 'Please enter a valid city',
            };
        }
        var containsPOBox = addressFieldContainsPOBox(value);
        setIsValid === null || setIsValid === void 0 ? void 0 : setIsValid(!containsPOBox);
        return containsPOBox
            ? {
                isValid: false,
                error: 'We currently do not deliver to PO boxes, please enter a new address',
            }
            : { isValid: true, error: '' };
    };
    var validateZipcode = function (value) {
        var isValid = isValidValue('zipcode', value);
        if (!isValid) {
            setIsValid === null || setIsValid === void 0 ? void 0 : setIsValid(false);
            return {
                isValid: false,
                error: 'Please enter a valid zip code',
            };
        }
        var containsPOBox = addressFieldContainsPOBox(value);
        setIsValid === null || setIsValid === void 0 ? void 0 : setIsValid(!containsPOBox);
        return containsPOBox
            ? {
                isValid: false,
                error: 'We currently do not deliver to PO boxes, please enter a new address',
            }
            : { isValid: true, error: '' };
    };
    return (_jsxs(_Fragment, { children: [_jsx(LocationSearchInput, { disabled: serverLoading, handleAddressSelected: handleAddressSelected, id: "street-address", label: "Street Address", onInputChange: handleStreetChange, setIsValid: setIsValid, value: street }), _jsx(FormInputRegular, { autoComplete: "address-line2", id: "apt", label: "Apartment / Unit", onInputChange: setApt, type: "text", required: false, validate: validateApt, value: apt, disabled: serverLoading }), _jsx(FormInputRegular, { autoComplete: "address-level2", id: "city", label: "City", onInputChange: setCity, type: "text", validate: validateCity, value: city, disabled: serverLoading }), _jsx(DropdownSelect, { autoComplete: "address-level1", label: "State", id: "state", onChange: setState, options: Object.keys(eligibleStates).map(function (stateCode) { return ({
                    value: stateCode,
                    label: eligibleStates[stateCode],
                }); }), placeholder: "State", required: true, value: state, disabled: serverLoading }), _jsx(FormInputRegular, { autoComplete: "postal-code", id: "zipcode", label: "Zip Code", maxLength: 5, onInputChange: setZipcode, pattern: "\\d{5}", type: "text", validate: validateZipcode, value: zipcode, disabled: serverLoading })] }));
};
export default AddressInput;
